import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import useCountUp from '../useCountUp';
import LogoImage from './lol-worlds.png';
import {
  Container,
  ImageContainer,
  Time,
  TimeContainer,
  Title,
} from './styles';

function CountUpLolWorldsSimple({ data, styles }) {
  const haveTitle = !!data.title;

  const [hours, minutes, seconds] = useCountUp({
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        {haveTitle && (
          <Title
            style={{
              color: styles.title.color,
            }}
          >
            {data.title}
          </Title>
        )}
        <TimeContainer>
          <ImageContainer
            style={{
              background: styles.logo.background,
            }}
          >
            <img src={LogoImage} alt="Lol Worlds Logo" />
          </ImageContainer>
          <Time
            style={{
              background: styles.timer.background,
              color: styles.timer.color,
            }}
          >
            {`${hours}:${minutes}:${seconds}`}
          </Time>
        </TimeContainer>
      </Container>
    </>
  );
}

CountUpLolWorldsSimple.propTypes = {
  data: PropTypes.shape({
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    logo: PropTypes.shape({
      background: PropTypes.string,
    }),
    timer: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
};

CountUpLolWorldsSimple.defaultProps = {
  data: {
    status: 'paused',
    time: [],
    title: 'Worlds League of legends',
  },
  styles: {
    logo: {
      background: '#0041F4',
    },
    timer: {
      background: '#151515',
      color: '#ffffff',
    },
    title: {
      color: '#000000',
    },
  },
};

export default CountUpLolWorldsSimple;
